import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'
import React from 'react'
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, Label, ResponsiveContainer, } from "recharts";


const useStyles = makeStyles(() => ({
    paper: {
        width: '100%',
        minHeight: '460px',
    },

}))

const listChart = {
    KPI: 'Коэффициента ключевых показателей эффективности - K',
    n: 'Количество нарушений бригады - N',
    w: 'Уровень риска - W',  
    r: 'Количество повторов нарушений - R',
    t: 'Время устранения нарушений - T',
    NPT: 'Показатель непроизводственного времени - NPT',
}


export const Chart = ({
    keyName,
    name,
    pokaz,
}) => {
    const classes = useStyles()


    return (
        <Paper className={classes.paper} elevation={5}>
            <Grid container direction='row' justifyContent='center'>
                <Grid item xs={12} style={{marginTop: '10px', textAlign: 'center'}}>
                    <Typography variant='h6'>
                        {listChart[keyName]}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <ResponsiveContainer width={'100%'}  height={400}>
                        <LineChart
                            data={pokaz}
                            margin={{ top: 20, right: 30, left: 30, bottom: 30 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey={'name'}>
                                <Label value={'Дата'} offset={0} position="bottom" />
                            </XAxis>
                            <YAxis>
                                <Label
                                    value={name}
                                    angle={"-90"}
                                    position="insideBottomLeft"
                                />
                            </YAxis>
                            <Tooltip />
                            <Legend align="center" verticalAlign="top" height={36} />
                            <Line type='linear' dataKey={keyName} stroke="red" activeDot={{ r: 4 }} />
                        </LineChart>
                    </ResponsiveContainer>
                </Grid>
            </Grid>
        </Paper>
    )
}
